import { z } from 'zod';

type T = (key: string) => string;

export const createStorageLocationSchema = (t: T) =>
  z.object({
    name: z.string().min(1, t('nameRequired')).max(50, t('nameMax')),
    capacity: z
      .number()
      .int()
      .min(1, t('capacityMin'))
      .or(
        z
          .string()
          .transform((v) => parseInt(v))
          .pipe(z.number().int().min(1, t('capacityMin')))
      ),
    notes: z
      .string()
      .max(500, t('notesMax'))
      .optional()
      .transform((v) => v || null)
      .nullable()
  });
